<template>
  <div id="app">
    <router-view></router-view>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr'
export default {
  name: 'app',
  mounted () {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish()
    miniToastr.init()
  },
  created () {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        // parse meta tags
        this.$Progress.parseMeta(meta)
      }
      //  start the progress bar
      this.$Progress.start()
      //  continue to next page
      next()
    })
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish()
    })
  },
}
</script>

<style lang="scss" type="text/scss">
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;
  .router-link-active {
    border-bottom: 1px solid #3D484F;
  }
  .kuzco-green {
    background-color: $kuzcogreen !important;
  }
  .input.is-active, .input.is-focused, .input:active, .input:focus, .textarea.is-active, .textarea.is-focused, .textarea:active, .textarea:focus {
    border-color: $kuzcogreen;
  }
  p {
    font-size: 2.5vmin;
  }
  @font-face {
    font-family: 'Huge Avant Garde';
    src: url('./assets/fonts/huge_agb_v5.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Proxima Bold';
    src: url('./assets/fonts/proximanova-bold-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Proxima Regular';
    src: url('./assets/fonts/proximanova-regular-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Proxima Regular Italic';
    src: url('./assets/fonts/proximanova-regularitalic-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Proxima SemiBold';
    src: url('./assets/fonts/proximanova-semibold-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat Light';
    src: url('./assets/fonts/Montserrat-Light.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat Regular';
    src: url('./assets/fonts/Montserrat-Regular.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat SemiBold';
    src: url('./assets/fonts/Montserrat-SemiBold.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  * {
    box-sizing: border-box;
    font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  html {
    font-size: 62.5%;
  }

  .headway-app {
    display: inline-block;
  }

  .active {
    font-weight: bold;
  }

  .text-white {
    color: #fff;
  }

  .text-black {
    color: #000;
  }

  .text-grey {
    color: #ccc
  }

  .text-u-c {
    text-transform: uppercase;
  }

  .text-l-t {
    text-decoration: line-through;
  }

  .text-u-l {
    text-decoration: underline;
  }

  .text-3x {
    font-size: 3em;
  }

  .text-2x {
    font-size: 2em;
  }

  .text-lg {
    font-size: 20px;
  }

  .text-md {
    font-size: 19px;
  }

  .text-base {
    font-size: 16px;
  }

  .text-sm {
    font-size: 15px;
  }

  .text-xs {
    font-size: 14px;
  }

  .text-xxs {
    text-indent: -9999px;
  }

  .text-xxxs {
    font-size: 0.5em;
  }

  .text-center {
    text-align: center;
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  .text-justify {
    text-align: justify;
  }

  .l-h {
    line-height: 1.42857143;
  }

  .l-h-0x {
    line-height: 0;
  }

  .l-h-1x {
    line-height: 1.2;
  }

  .l-h-2x {
    line-height: 2em;
  }

  .l-s-1x {
    letter-spacing: 1px;
  }

  .l-s-2x {
    letter-spacing: 2px;
  }

  .l-s-3x {
    letter-spacing: 3px;
  }

  .font-normal {
    font-weight: normal;
  }

  .font-thin {
    font-weight: 300;
  }

  .font-bold {
    font-weight: 600;
  }

  .font-bolder {
    font-weight: 700;
  }

  .no-line {
    border-width: 0;
  }

  .border-eee {
    border: 1px solid #c9d0e1;
  }

  .no-border,
  .no-borders {
    border-color: transparent;
    border-width: 0 !important;
  }

  .no-border-right {
    border-right: 0;
  }

  .no-border-left {
    border-left: 0;
  }

  .no-border-top {
    border-top: 0;
  }

  .one-radius {
    border-radius: 1px;
  }

  .no-radius {
    border-radius: 0;
  }

  .block {
    display: block !important;
  }

  .block.hide {
    display: none;
  }

  .inline {
    display: inline-block !important;
  }

  .none {
    display: none;
  }

  .pull-none {
    float: none;
  }

  .greencolor {
    color: #1b9aa9
  }

  .rounded {
    border-radius: 500px;
  }

  .clear {
    display: block;
    overflow: hidden;
  }

  .no-bg {
    background-color: transparent;
    color: inherit;
  }

  .bg-white {
    background-color: white;
  }

  .bg-blue {
    background-color: #F7F9FA;
  }

  .bg-ash {
    background-color: #EEE;
  }

  .pos-rlt {
    position: relative;
  }

  .pos-stc {
    position: static !important;
  }

  .pos-abt {
    position: absolute;
  }

  .pos-fix {
    position: fixed;
  }

  .show {
    visibility: visible;
  }

  .line {
    width: 100%;
    height: 2px;
    margin: 10px 0;
    font-size: 0;
    overflow: hidden;
  }

  .line-xs {
    margin: 0;
  }

  .line-lg {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .wrapper-xs {
    padding: 5px;
  }

  .wrapper-sm {
    padding: 10px;
  }

  .wrapper {
    padding: 15px;
  }

  .wrapper-md {
    padding: 20px;
  }

  .wrapper-lg {
    padding: 30px;
  }

  .wrapper-xl {
    padding: 50px;
  }

  .padder-lg {
    padding-left: 30px;
    padding-right: 30px;
  }

  .padder-xl {
    padding-left: 40px;
    padding-right: 40px;
  }

  .padder-xxl {
    padding-left: 50px;
    padding-right: 50px;
  }

  .padder-md {
    padding-left: 20px;
    padding-right: 20px;
  }

  .padder {
    padding-left: 15px;
    padding-right: 15px;
  }

  .padder-v {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .padder-v-sm {
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .padder-v-xsm {
    padding-top: 2px;
    padding-bottom: 2px;
  }

  .no-padder {
    padding: 0 !important;
  }

  .p-b {
    padding-bottom: 15px;
  }

  .p-b-md {
    padding-bottom: 20px;
  }

  .p-b-lg {
    padding-bottom: 30px;
  }

  .p-b-xl {
    padding-bottom: 40px;
  }

  .p-b-xxl {
    padding-bottom: 50px;
  }

  .p-t {
    padding-top: 15px;
  }

  .p-t-md {
    padding-top: 20px;
  }

  .p-t-lg {
    padding-top: 30px;
  }

  .p-t-xl {
    padding-top: 40px;
  }

  .p-t-xxl {
    padding-top: 50px;
  }

  .font-danger {
    color: red;
  }

  .m-xxs {
    margin: 2px 4px;
  }

  .m-xs {
    margin: 5px;
  }

  .m-sm {
    margin: 10px;
  }

  .m {
    margin: 15px;
  }

  .m-md {
    margin: 20px;
  }

  .m-lg {
    margin: 30px;
  }

  .m-xl {
    margin: 50px;
  }

  .m-n {
    margin: 0 !important;
  }

  .m-l-none {
    margin-left: 0 !important;
  }

  .m-l-xs {
    margin-left: 5px;
  }

  .m-l-sm {
    margin-left: 10px;
  }

  .m-l {
    margin-left: 15px;
  }

  .m-l-mobile {
    margin-left: 15px !important;
  }

  .m-l-md {
    margin-left: 20px;
  }

  .m-l-lg {
    margin-left: 30px;
  }

  .m-l-xl {
    margin-left: 40px;
  }

  .m-l-xxl {
    margin-left: 50px;
  }

  .m-l-n-xxs {
    margin-left: -1px;
  }

  .m-l-n-xs {
    margin-left: -5px;
  }

  .m-l-n-sm {
    margin-left: -10px;
  }

  .m-l-n {
    margin-left: -15px;
  }

  .m-l-n-md {
    margin-left: -20px;
  }

  .m-l-n-lg {
    margin-left: -30px;
  }

  .m-l-n-xl {
    margin-left: -40px;
  }

  .m-l-n-xxl {
    margin-left: -50px;
  }

  .m-t-none {
    margin-top: 0 !important;
  }

  .m-t-xxs {
    margin-top: 2px;
  }

  .m-t-xs {
    margin-top: 5px;
  }

  .m-t-sm {
    margin-top: 10px;
  }

  .m-t {
    margin-top: 15px;
  }

  .m-t-md {
    margin-top: 20px;
  }

  .m-t-lg {
    margin-top: 30px;
  }

  .m-t-xl {
    margin-top: 40px;
  }

  .m-t-xxl {
    margin-top: 50px;
  }

  .m-t-bg {
    margin-top: 100px;
  }

  .m-t-n-xxs {
    margin-top: -1px;
  }

  .m-t-n-xs {
    margin-top: -5px;
  }

  .m-t-n-sm {
    margin-top: -10px;
  }

  .m-t-n {
    margin-top: -15px;
  }

  .m-t-n-md {
    margin-top: -20px;
  }

  .m-t-n-lg {
    margin-top: -30px;
  }

  .m-t-n-xl {
    margin-top: -40px;
  }

  .m-t-n-xxl {
    margin-top: -50px;
  }

  .m-r-none {
    margin-right: 0 !important;
  }

  .m-r-xxs {
    margin-right: 1px;
  }

  .m-r-xs {
    margin-right: 5px;
  }

  .m-r-sm {
    margin-right: 10px;
  }

  .m-r {
    margin-right: 15px;
  }

  .m-r-n {
    margin-right: -15px;
  }

  .m-r-md {
    margin-right: 20px;
  }

  .m-r-lg {
    margin-right: 30px;
  }

  .m-r-xl {
    margin-right: 40px;
  }

  .m-r-xxl {
    margin-right: 50px;
  }

  .m-r-n-xxs {
    margin-right: -1px;
  }

  .m-r-n-xs {
    margin-right: -5px;
  }

  .m-r-n-sm {
    margin-right: -10px;
  }

  .m-r-n {
    margin-right: -15px;
  }

  .m-r-n-md {
    margin-right: -20px;
  }

  .m-r-n-lg {
    margin-right: -30px;
  }

  .m-r-n-xl {
    margin-right: -40px;
  }

  .m-r-n-xxl {
    margin-right: -50px;
  }

  .m-b-none {
    margin-bottom: 0 !important;
  }

  .m-b-xxs {
    margin-bottom: 1px;
  }

  .m-b-xs {
    margin-bottom: 5px;
  }

  .m-b-sm {
    margin-bottom: 10px;
  }

  .m-b {
    margin-bottom: 15px;
  }

  .m-b-md {
    margin-bottom: 20px;
  }

  .m-b-lg {
    margin-bottom: 30px;
  }

  .m-b-xl {
    margin-bottom: 40px;
  }

  .m-b-xxl {
    margin-bottom: 50px;
  }

  .m-b-n-xxs {
    margin-bottom: -1px;
  }

  .m-b-n-xs {
    margin-bottom: -5px;
  }

  .m-b-n-sm {
    margin-bottom: -10px;
  }

  .m-b-n {
    margin-bottom: -15px;
  }

  .m-b-n-md {
    margin-bottom: -20px;
  }

  .m-b-n-lg {
    margin-bottom: -30px;
  }

  .m-b-n-xl {
    margin-bottom: -40px;
  }

  .m-b-n-xxl {
    margin-bottom: -50px;
  }

  .p-l-none {
    padding-left: 0 !important;
  }

  .p-r-none {
    padding-right: 0 !important;
  }

  .p-big {
    padding: 0 60px;
  }

  .p-huge {
    padding: 0 80px;
  }

  .w-1x {
    width: 1em;
  }

  .w-2x {
    width: 2em;
  }

  .w-3x {
    width: 3em;
  }

  .w-xxs {
    width: 60px;
  }

  .w-xs {
    width: 90px;
  }

  .w-sm {
    width: 150px;
  }

  .w {
    width: 200px;
  }

  .w-md {
    width: 240px;
  }

  .w-lg {
    width: 280px;
  }

  .w-xl {
    width: 320px;
  }

  .w-xxl {
    width: 360px;
  }

  .w-access {
    width: 420px;
  }

  .w-mid {
    width: 500px;
  }

  .w-full {
    width: 100%;
  }

  .w-auto {
    width: auto;
  }

  .h-auto {
    height: auto;
  }

  .h-full {
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// App.vue?b843bcd2